'use strict';
var _ = require('lodash');
var $ = require('jquery');
var Backbone = require('backbone');
Backbone.$ = $;

// relative utils
require('./util/mixin');
require('./util/plugin');

// shimmed modules
require('bootstrap-button');
require('focus-visible');

_.noConflict();
$.noConflict(true);
Backbone.noConflict();

var App = require('./App');
var AppClassName = 'telescopeappdwts';

/**
 *
 * @param options
 * {
 * widget_id: 'data/data.json' // REQUIRED string
 * container: $('#myApp') // REQUIRED string || jQuery selector (http://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * modal: $('#wrapper') // string || jQuery selector (http://api.jquery.com/jQuery/) || element reference (https://developer.mozilla.org/en-US/docs/Web/API/element)
 * uniqueId: 'name-type-namespace-rev' // string
 * cssUrl: 'http://a1.telesocpe.tv/styles/main.css' // absolute path
 * cssIsUnique: true // boolean - if true css should use an ID selector for the namespacing, otherwise use a class selector for the namespacing and restrict loading and injection of style block to a single execution
 * hashState: false // boolean - when true, enables hashable routes **for testing - only set to true when instantiation of the widget is limited to one object per frameElement/window
 * endpoints: {cms: '//https://widgetstate.votenow.tv/v1/state/'} // object
 * }
 */
module.exports = function(options){

    options = options || {};

    options.container = $(options.container || document.body) ;
    options.modal = $(options.modal || options.container);

    options.cssIsUnique = (typeof options.cssIsUnique === 'undefined'? true : options.cssIsUnique);

    options.uniqueId = options.uniqueId
        || $(options.container).attr('id')
        || (function(){
            var retval = AppClassName;
            if(options.widget_id) {
                retval += '-' + options.widget_id + '-';
            }
            retval += (Date.now() % 1e6);
            return retval;
        }());

    if(!$(options.uniqueId).length) {
        $(options.container).attr('id', options.uniqueId);
    }

    App(options);
};



// WEBPACK FOOTER //
// ./app/scripts/main.js